import { FunctionComponent } from 'react'
import StarIcon from './Icon/StarIcon'

type ScoringProps = {
	//
}

type ScoringRowProps = {
	label: string
	stars: number
}

const ScoringRow: FunctionComponent<ScoringRowProps> = ({ label, stars }) => (
	<div className="stat-row">
		<div className="stat-row__label">{label}</div>
		<div className="stat-row__val">
			{Array.from({ length: stars }, (_, i) => (
				<StarIcon key={i} filled />
			))}
		</div>
	</div>
)

const Scoring: FunctionComponent<ScoringProps> = () => (
	<div className="scoring">
		<h2>Scoring</h2>
		<div className="post-game-stats-table">
			<ScoringRow label="1 minute or less" stars={5} />
			<ScoringRow label="2 minutes or less" stars={4} />
			<ScoringRow label="3 minutes or less" stars={3} />
			<ScoringRow label="4 minutes or less" stars={2} />
			<ScoringRow label="Anything else" stars={1} />
		</div>
	</div>
)

export default Scoring
